import FontBody3 from '../../../components/fonts/font-body3/font-body3';
import { FONT_COLOR, FONT_VARIANT } from '../../../components/fonts/font-props';
import { ButtonIcon } from '../../../components/inputs/button-icon/button-icon';
import IconCopy from '../../../components/icons/icon-copy/icon-copy';
import TextTruncate from '../../../components/text-truncate/text-truncate';
import { Tooltip } from '../../../components/tooltip/tooltip';
import { TOOLTIP_PLACEMENTS } from '../../../components/tooltip/tooltip-box';
import useDashboardTranslation from '../../../dashboard-translation/hooks/dashboard-translation-hook';

interface IProps {
    address?: string;
    /** When false, the cell shows "Not required" (gift returns); tooltip and copy still use `address`. */
    isAddressRequired?: boolean;
}

function safeCopyToClipboard(text: string): void {
    if (!document.hasFocus()) {
        return;
    }
    try {
        navigator.clipboard.writeText(text);
    } catch (err) {
        console.error(`Could not copy text:${text}; Clipboard API might be not supported.`, err);
    }
}

/** Address grid cell: truncated text with a full-value tooltip and a copy button. */
const CustomerDataCardAddressValue: React.FC<IProps> = ({
    address,
    isAddressRequired = true,
}) => {
    const pageScope = 'dashboard-create-rma';
    const { getTranslation } = useDashboardTranslation();
    const noData = getTranslation('NO_DATA', pageScope);
    const addressText = address ?? noData;
    const cellText = isAddressRequired ? addressText : getTranslation('NOT_REQUIRED', pageScope);

    return (
        <div className="customer-data-card-address-container">
            <Tooltip
                placement={TOOLTIP_PLACEMENTS.BOTTOM}
                content={
                    <div className="customer-data-card-address-tooltip">
                        <FontBody3 color={FONT_COLOR.NEUTRAL_1_WHITE} variant={FONT_VARIANT.DEFAULT}>
                            {addressText}
                        </FontBody3>
                    </div>
                }
            >
                <TextTruncate preventDefaultTooltip>
                    <FontBody3 color={FONT_COLOR.PRIMARY2} variant={FONT_VARIANT.BOLD}>
                        {cellText}
                    </FontBody3>
                </TextTruncate>
            </Tooltip>
            {address && (
                <ButtonIcon Component={IconCopy} onClick={() => safeCopyToClipboard(address)} />
            )}
        </div>
    );
};

export default CustomerDataCardAddressValue;
